import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId.js';

export const WebhookGetParamsValidationSchema = z.object({
  webhookId: ObjectIdStringValidationSchema.meta({
    description: 'The webhook ID, as returned by create or list.',
  }),
});
